import React from "react";
import { Link } from "react-router-dom";

export default function AuditCta({ context = "audit-cta" }) {
  return (
    <div
      className="dt6-card p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between"
      style={{ background: "var(--dt6-surface)" }}
      data-testid={context}
    >
      <div>
        <div className="dt6-chip dt6-chip-primary mb-3">FLAGSHIP FUNNEL</div>
        <h3 className="font-heading text-2xl md:text-3xl font-bold">Free voter file audit.</h3>
        <p className="text-[color:var(--dt6-muted)] max-w-xl mt-2">
          Upload up to 5,000 records. We return a health report: undeliverable, movers, deceased, duplicates,
          missing phone or email, TCPA exposure. Turnaround in 3 business days.
        </p>
      </div>
      <div className="flex gap-3">
        <Link to="/audit" className="dt6-btn dt6-btn-primary" data-testid={`${context}-btn`}>Start audit</Link>
        <Link to="/platform" className="dt6-btn" data-testid={`${context}-secondary`}>See the stack</Link>
      </div>
    </div>
  );
}
